module.exports = __webpack_public_path__ + "static/media/plate-en.41a8b420.svg";